module.exports = __webpack_public_path__ + "static/media/shopify7.ab70a952.png";